"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var clipboard_1 = __importDefault(require("clipboard"));
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var __1 = require("../");
util_localization_1.default.addTranslations('de', {
    "Couldn't copy": 'Kopieren nicht möglich',
    'copied $0': '$0 wurde kopiert',
});
function Clipboard(_a) {
    var children = _a.children, onCopy = _a.onCopy, textProp = _a.text;
    var clipRef = react_1.useRef(null);
    var _b = react_1.useState(), copiedText = _b[0], setCopiedText = _b[1];
    react_1.useEffect(function () {
        var element = clipRef.current;
        if (element === null)
            return;
        var clipInstance = new clipboard_1.default(element, {
            text: function (trigger) {
                var _a;
                var text = (_a = textProp !== null && textProp !== void 0 ? textProp : trigger.textContent) !== null && _a !== void 0 ? _a : util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Couldn't copy"], ["Couldn't copy"])));
                onCopy === null || onCopy === void 0 ? void 0 : onCopy(text);
                setCopiedText(text);
                return text;
            },
        });
        return function () {
            clipInstance.destroy();
        };
    }, [clipRef]);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", __assign({ ref: clipRef, style: { cursor: 'pointer' } }, { children: children }), void 0),
            jsx_runtime_1.jsx(__1.SimpleSnackbar, { info: copiedText && util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["copied ", ""], ["copied ", ""])), copiedText), onClose: function () { return setCopiedText(undefined); } }, void 0)] }, void 0));
}
exports.default = Clipboard;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Clipboard.js.map